import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CityListComponent } from './city-list/city-list.component';
import { CityCreateComponent } from './city-create/city-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: CityListComponent,
        data: {
          title: "City List",
          breadcrumb: "City List"
        }
      },
      {
        path: 'create',
        component: CityCreateComponent,
        data: {
          title: "Create City",
          breadcrumb: "Create City"
        }
      },
      {
        path: 'edit/:id',
        component: CityCreateComponent,
        data: {
          title: "Edit City",
          breadcrumb: "Edit City"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class CityRoutingModule { }
